import about from './about';
export default about;
